import { useEffect, useState } from 'react';
import { Form } from 'antd';

import useEgresado from "./../../../../hooks/HookEgresado";
import useLocalidad from './../../../../../../hooks/HookLocalidades';

const useFormEditInfo = (onCancelModal) => {
    const { alumno, loadingEgresado, updateInformacion, getProfile } = useEgresado();
    const { catLocalidades, getLocalidadesByCP } = useLocalidad();
    const [cpValidated, setCpValidated] = useState(true);
    const [form] = Form.useForm();

    // Efecto para obtener la localidad y configurar el formulario
    useEffect(() => {
        if (alumno?.colonia?.codigo_postal) {
            getLocalidadesByCP(alumno?.colonia?.codigo_postal);
        }

        form.setFieldsValue({
            objetivo_profesional: alumno?.objetivo_profesional,
            correo_alternativo: alumno?.correo_alternativo,
            correo_personal: alumno?.correo_personal,
            telefono_personal: alumno?.telefono_personal,
            calle_y_numero: alumno?.calle_y_numero,
            codigo_postal: alumno?.colonia?.codigo_postal,
            id_colonia: alumno?.colonia?.id_localidad,
            municipio: alumno?.colonia?.municipio?.nombre_municipio,
            estado: alumno?.colonia?.municipio?.estado?.nombre_estado
        });
    }, []);

    const onUpdateInformacion = async () => {
        try {
            const values = await form.validateFields();
            const response = await updateInformacion(values);

            if (!response.success) return;
            getProfile();
            onCancelModal();
        }
        catch (error) {
            //console.log(error);
        }
    };

    return {
        form,
        onUpdateInformacion,
        loadingEgresado,
        catLocalidades,
        cpValidated,
        setCpValidated,
        getLocalidadesByCP
    };
};

export default useFormEditInfo;
